import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css'
import themeColors from '@/styles/colors'
import QKnob from 'quasar/src/components/knob/QKnob.js';import QFab from 'quasar/src/components/fab/QFab.js';import QFabAction from 'quasar/src/components/fab/QFabAction.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import Quasar from 'quasar/src/vue-plugin.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';import QCard from 'quasar/src/components/card/QCard.js';import QForm from 'quasar/src/components/form/QForm.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QInput from 'quasar/src/components/input/QInput.js';import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QStep from 'quasar/src/components/stepper/QStep.js';import QStepper from 'quasar/src/components/stepper/QStepper.js';import QTable from 'quasar/src/components/table/QTable.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QTh from 'quasar/src/components/table/QTh.js';import QTd from 'quasar/src/components/table/QTd.js';import QTr from 'quasar/src/components/table/QTr.js';import QTree from 'quasar/src/components/tree/QTree.js';import QUploader from 'quasar/src/components/uploader/QUploader.js';import QPagination from 'quasar/src/components/pagination/QPagination.js';import QDate from 'quasar/src/components/date/QDate.js';import QTime from 'quasar/src/components/time/QTime.js';import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';import QFile from 'quasar/src/components/file/QFile.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QBar from 'quasar/src/components/bar/QBar.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QItem from 'quasar/src/components/item/QItem.js';import QChip from 'quasar/src/components/chip/QChip.js';import QField from 'quasar/src/components/field/QField.js';import QSlider from 'quasar/src/components/slider/QSlider.js';import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QList from 'quasar/src/components/item/QList.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPage from 'quasar/src/components/page/QPage.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';

export default function useQuasar(app) {
    app.use(Quasar, {
        config: {
            brand: {
                primary: themeColors.primary,
                secondary: themeColors.secondary,
                accent: themeColors.tertiary,
                dark: '#1d1d1d',
                positive: '#30a144',
                negative: '#af2724',
                info: '#148699',
                warning: '#dc9a00',
            },
        },
        components: {
            QKnob,
            QFab,
            QFabAction,
            QBadge,
            QBanner,
            QBtnToggle,
            QBtnDropdown,
            QCard,
            QBtn,
            QCardSection,
            QCheckbox,
            QForm,
            QInput,
            QIcon,
            QLinearProgress,
            QRadio,
            QSelect,
            QSeparator,
            QStep,
            QStepper,
            QTabs,
            QTab,
            QTable,
            QTabPanel,
            QTabPanels,
            QToggle,
            QTooltip,
            QTh,
            QTd,
            QTr,
            QTree,
            QUploader,
            QPagination,
            QDate,
            QTime,
            QCircularProgress,
            QFile,
            QDialog,
            QBar,
            QSpace,
            QExpansionItem,
            QCardActions,
            QScrollArea,
            QItemSection,
            QAvatar,
            QItem,
            QChip,
            QField,
            QSlider,
            QPopupEdit,
            QPopupProxy,
            QMenu,
            QList,
            QItemLabel,
            QOptionGroup,
            QToolbar,
            QToolbarTitle,
            QLayout,
            QDrawer,
            QPageContainer,
            QPage,
            QFooter,
            QHeader,
            QSlideTransition,
        },
        plugins: {
            Notify,
        },
    })
}
